/**
 * Sym — one Material Symbols Rounded glyph, the icon set the shell design specifies
 * (design_handoff_navigation_shell "Assets"). The variable `wght` axis is the point:
 * the rail's active state is a 300→400 weight shift on the same glyph, which a
 * stroke-width swap on another icon set can only approximate.
 *
 * lucide stays the app's icon set everywhere else — this is chrome only.
 */

import React from 'react'
import clsx from 'clsx'

export default function Sym({
  name,
  size = 21,
  weight = 300,
  fill = 0,
  className,
  style,
}: {
  name: string
  size?: number
  weight?: 300 | 400
  fill?: 0 | 1
  className?: string
  style?: React.CSSProperties
}): React.JSX.Element {
  return (
    <span
      aria-hidden="true"
      className={clsx('material-symbols-rounded', className)}
      style={{
        fontSize: size,
        lineHeight: 1,
        fontVariationSettings: `'FILL' ${fill}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`,
        ...style,
      }}
    >
      {name}
    </span>
  )
}
